import { Alert } from '@cmsgov/ds-medicare-gov';
import Caret from '@cmsgov/ds-medicare-gov/dist/components/Caret/Caret';
import React, { useState } from 'react';
import { allow } from '../../common/classes/allow';
import ApiErrorAlert from '../../common/components/api.error.alert';
import EnterPasswordSection from '../../common/components/account-trouble/enter.password.section';
import Button from '../../common/components/button';
import Checkbox from '../../common/components/checkbox';
import Div from '../../common/components/div';
import DropDown from '../../common/components/dropdown';
import H1 from '../../common/components/h1';
import H2 from '../../common/components/h2';
import H3 from '../../common/components/h3';
import H5 from '../../common/components/h5';
import InputField from '../../common/components/input.field';
import StackingButtons from '../../common/components/stacking.buttons';
import SubHeading from '../../common/components/sub.heading.section';
import TranslatedSpan from '../../common/components/translated.span';
import ValidationAlertMessage from '../../common/components/validation.alert.message';
import ValidationAlerts from '../../common/components/validation.alerts';
import capitalizeFirstLetter from '../../common/functions/capitalize.first.letter';
import capitalizeWords from '../../common/functions/capitalize.words';
import translate from '../../common/functions/translate';
import { useConversion, useFormStart } from '../../common/hooks/use.analytics';
import { usePageTitle } from '../../common/hooks/use.page.title';
import useTrait from '../../common/hooks/use.trait';
import useUpdateAccountApi from '../../common/hooks/use.update.account.api';
import useViewport from '../../common/hooks/use.viewport';
import the from '../../common/objects/the';
import { get400InvalidUsernameOrPasswordError, hasInvalidField } from '../../common/functions/get.api.error.message';
import { TermsAndConditions } from '../../common/components/terms.and.conditions';

export default function UpdateAccountSection(props) {
    const [agreementCheckedRef, setAgreementCheckedRef] = useState();
    const [confirmEmailAddressRef, setConfirmEmailAddressRef] = useState();
    const [confirmNewPasswordRef, setconfirmNewPasswordRef] = useState();
    const [currentPasswordRef, setCurrentPasswordRef] = useState();
    const [emailAddressRef, setEmailAddressRef] = useState();
    const [newPasswordRef, setNewPasswordRef] = useState();
    const [secretAnswerRef, setSecretAnswerRef] = useState();
    const [secretQuestionRef, setSecretQuestionRef] = useState();
    const [termsAndConditionsDisplayed, setTermsAndConditionsDisplayed] = useState(false);
    const [passwordToggle, setTogglePassword] = useState(false);
    const [usernameToggle, setToggleUsername] = useState(false);
    const [currentPasswordDisplayed, setToggleCurrentPassword] = useState(false);
    const [currentPasswordExpand, setCurrentPasswordExpand] = useState(false);
    const [currentPasswordDisplay, setCurrentPasswordDisplay] = useState(false);
    const [expand, setExpand] = useState(false);
    const [display, setDisplay] = useState(false);
    const [passwordExpand, setPasswordExpand] = useState(false);
    const [passwordDisplay, setPasswordDisplay] = useState(false);
    const [usernameExpand, setUsernameExpand] = useState(false);
    const [usernameDisplay, setUsernameDisplay] = useState(false);
    const [usernameRef, setUsernameRef] = useState();
    const agreementChecked = useTrait(false);
    const agreementCheckedError = useTrait(false);
    const apiErrorMessage = useTrait(null);
    const confirmEmailAddress = useTrait('');
    const confirmEmailAddressError = useTrait(false);
    const confirmNewPassword = useTrait('');
    const confirmNewPasswordError = useTrait(false);
    const currentPassword = useTrait('');
    const currentPasswordError = useTrait(false);
    const emailAddress = useTrait('');
    const emailAddressError = useTrait(false);
    const newPassword = useTrait('');
    const newPasswordError = useTrait(false);
    const noEmailAddressChecked = useTrait(false);
    const secretAnswer = useTrait('');
    const secretAnswerError = useTrait(false);
    const secretQuestion = useTrait('');
    const secretQuestionError = useTrait(false);
    const username = useTrait('');
    const usernameError = useTrait(false);
    const validateEntireForm = useTrait(false);
    const validationMessages = useTrait([]);
    const updateAccountApi = useUpdateAccountApi();
    const formStart = useFormStart('updated_account');
    const conversion = useConversion('update account', 'updated_account');
    const counter = useTrait(0);
    const {width} = useViewport();
    const [isLoading, setIsLoading] = useState(false);
   
    usePageTitle(translate('Update Account'));
   
    const {temporaryUsername, temporaryPassword, usernameVisible, passwordVisible, secretQuestionVisible, emailVisible, showPageCallBack, resetLoginFlow, ...remainingProps} = props;
   
    const getCancelButton = () => {
        return <>
            <Button
                color={'teal'}
                displayAs={'button'}
                fill={'outlined'}
                onClick={() => props.resetLoginFlow()}
                size={'small'}
            >
                <TranslatedSpan english={'Cancel'}/>
            </Button>
        </>;
    };
   
    const getUpdateAccountButton = () => {
        return <>
            <Button
                color={'teal'}
                displayAs={'button'}
                fill={'solid'}
                onClick={handleUpdateAccountButtonClick}
                size={'small'}
                isLoading={isLoading}
            >
                <TranslatedSpan english={'Update Account'}/>
            </Button>
        </>;
    };
   
    const reset = () => {
        apiErrorMessage.set(null);
    };
   
    const getValidationMessages = () => {
        const messages = [];
        if (!validateEntireForm.get())
            return messages;
        if (usernameVisible && !validateUsername()) {
            messages.push(
                <ValidationAlertMessage
                    description={translate('Please enter a username.')}
                    fieldReference={usernameRef}
                    linkText={translate('Username')}
                />
            );
        }
        if (passwordVisible && !validateCurrentPassword()) {
            messages.push(
                <ValidationAlertMessage
                    description={translate('Please enter a password.')}
                    fieldReference={currentPasswordRef}
                    linkText={translate('Current Password')}
                />
            );
        }
        if (passwordVisible && !validateNewPassword()) {
            messages.push(
                <ValidationAlertMessage
                    description={translate('Please enter a new password.')}
                    fieldReference={newPasswordRef}
                    linkText={capitalizeWords(translate('New password'))}
                />
            );
        }
        if (passwordVisible && !validateConfirmNewPassword()) {
            messages.push(
                <ValidationAlertMessage
                    description={translate('Please confirm your password.')}
                    fieldReference={confirmNewPasswordRef}
                    linkText={capitalizeWords(translate('Confirm new password'))}
                />
            );
        }
        if (secretQuestionVisible && !validateSecretQuestion()) {
            messages.push(
                <ValidationAlertMessage
                    description={translate('Please select a secret question.')}
                    fieldReference={secretQuestionRef}
                    linkText={translate('Secret Question')}
                />
            );
        }
        if (secretQuestionVisible && !validateSecretAnswer()) {
            messages.push(
                <ValidationAlertMessage
                    description={translate('Please enter a secret answer.')}
                    fieldReference={secretAnswerRef}
                    linkText={capitalizeWords(translate('Secret answer'))}
                />
            );
        }
        if (emailVisible && !validateEmailAddress()) {
            messages.push(
                <ValidationAlertMessage
                    description={translate('Enter your email address or select "I don\'t have an email address".')}
                    fieldReference={emailAddressRef}
                    linkText={translate('Email address')}
                />
            );
        }
        if (emailVisible && !validateConfirmEmailAddress()) {
            messages.push(
                <ValidationAlertMessage
                    description={translate('Confirm your email address or select "I don\'t have an email address".')}
                    fieldReference={confirmEmailAddressRef}
                    linkText={translate('Confirm email address')}
                />
            );
        }
        if (usernameVisible && passwordVisible && secretQuestionVisible && emailVisible && !validateAgreementChecked()) {
            messages.push(
                <ValidationAlertMessage
                    description={translate('Review and check the box to continue to the next step.')}
                    fieldReference={agreementCheckedRef}
                    linkText={capitalizeFirstLetter(translate('terms & conditions'))}
                />
            );
        }
        return messages;
    };
   
    const handleUpdateAccountButtonClick = () => {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
   
        conversion.attempt();
        const errorFieldRef = validateForm();
        if (errorFieldRef !== null) {
            errorFieldRef.focus();
            setIsLoading(false);
            return;
        }
   
        const getPostBody = () => {
            const updates = {};
         
            const challengeQuestionAndAnswers = [];
            if (usernameVisible) {
                updates['username'] = username.get();
            }
            if (passwordVisible) {
                updates['password'] = newPassword.get();
            }
            if (emailVisible) {
                updates['email'] = emailAddress.get();
            }
            if (secretQuestionVisible) {
                challengeQuestionAndAnswers.push({"question": secretQuestion.get(), "answer": secretAnswer.get()});
                updates['challengeQuestionAndAnswers'] = challengeQuestionAndAnswers;
            }
            return updates;
        };
        const headers = {
            headers: {
                'accept': '*/*',
                'content-type': 'application/json'
            }
        };
        updateAccountApi.updateAccount(temporaryUsername, currentPassword.get(), getPostBody(), headers, (result) => {
            setIsLoading(false);
            let success = false;
            const unknownErrorMessage = "We can't process your request at this time. We're sorry for any inconvenience. Please try again.";
            if (!result?.code) {
                conversion.failAPI('unknown error');
                apiErrorMessage.set(unknownErrorMessage);
                return;
            }
            switch (result.code) {
                    case 204:
                        reset();
                        conversion.success();
                        props.showPageCallBack(1);
                        break;
                    case 400:
                        reset();
                        const usernameOrPasswordError = get400InvalidUsernameOrPasswordError(result?.errors);
                        if (hasInvalidField(result?.errors, 'username')) {
                            // this should never happen - this error would be for invalid current username, which was correctly entered before this step
                            apiErrorMessage.set(unknownErrorMessage);
                        } else if (hasInvalidField(result?.errors, 'password')) {
                            // incorrect current password
                            apiErrorMessage.set('Your username or password doesn\'t match our records. Check the information you entered and try again.');
                        } else if (hasInvalidField(result?.errors, 'updates.email')) {
                            apiErrorMessage.set('Enter your email address or select "I don\'t have an email address".');
                        } else if (usernameOrPasswordError) {
                            apiErrorMessage.set(usernameOrPasswordError);
                        } else {
                            apiErrorMessage.set(unknownErrorMessage);
                        }
                        break;
                    case 401:
                        reset();
                        const count = counter.set(counter.get() + 1);
                        if (count <= 3)
                            apiErrorMessage.set('Your username or password doesn\'t match our records. Check the information you entered and try again.');
                        else if (count === 4)
                            apiErrorMessage.set('Your username and password doesn\'t match our records. You have 1 more try to re-enter your username and password. If it doesn\'t match our records, your accout will be locked.');
                        else
                            apiErrorMessage.set('Your account is locked to protect your information. You can try to log in again in 1 hour.');
                        break;
                    case 403:
                        reset();
                        apiErrorMessage.set('Your account is locked to protect your information. You can try to log in again in 1 hour.');
                        break;
                    case 404:
                        reset();
                        apiErrorMessage.set(unknownErrorMessage);
                        break;
                    case 409:
                        reset();
                        apiErrorMessage.set('The username that you supplied is not available.  Please choose a different username.');
                        break;
                    default:
                        reset();
                        apiErrorMessage.set(unknownErrorMessage);
                        break;
            }
   
            if (!success) {
                const errorMessage = apiErrorMessage.get() || 'unkown error';
                conversion.failAPIIntermediate(errorMessage);
                conversion.failAPI(errorMessage);
            }
   
        });
    };
   
    const questionList = [
        {label: translate('Select question'), value: ''},
        {label: translate('What is your favorite vacation spot?'), value: 'What is your favorite vacation spot?'},
        {label: translate('In what city did you first meet your spouse?'), value: 'In what city did you first meet your spouse?'},
        {label: translate('What country would you most like to visit?'), value: 'What country would you most like to visit?'},
        {label: translate('What is the title of your favorite book?'), value: 'What is the title of your favorite book?'},
        {label: translate('What is the name of the first street you lived on?'), value: 'What is the name of the first street you lived on?'},
        {label: translate('What was the name of your first pet?'), value: 'What was the name of your first pet?'},
        {label: translate(`What is your best friend's last name?`), value: `What is your best friend's last name?`}
    ];
   
    const toggleTermsAndConditions = () => setTermsAndConditionsDisplayed(current => !current);
    const togglePassword = () => setTogglePassword(current => !current);
    const toggleUsername = () => setToggleUsername(current => !current);
    const toggleCurrentPassword = () => setToggleCurrentPassword(current => !current);
   
    const updateUsername = (value = '') => {
        allow.aString(value);
        formStart();
        const newValue = value.trimStart();
        username.set(newValue);
        validateUsername();
        if (validateEntireForm.get())
            validateForm();
    };
   
    const updateCurrentPassword = (value = '') => {
        allow.aString(value);
        formStart();
        const newValue = value.trimStart();
        currentPassword.set(newValue);
        validateCurrentPassword();
        if (validateEntireForm.get())
            validateForm();
    };
   
    const updateNewPassword = (value = '') => {
        allow.aString(value);
        formStart();
        const newValue = value.trimStart();
        newPassword.set(newValue);
        validateNewPassword();
        if (validateEntireForm.get())
            validateForm();
    };
   
    const updateConfirmNewPassword = (value = '') => {
        allow.aString(value);
        formStart();
        const newValue = value.trimStart();
        confirmNewPassword.set(newValue);
        validateConfirmNewPassword();
        if (validateEntireForm.get())
            validateForm();
    };
   
    const updateSecretQuestion = (value = '') => {
        allow.aString(value);
        formStart();
        const newValue = value.trimStart();
        secretQuestion.set(newValue);
        validateSecretQuestion();
        if (validateEntireForm.get())
            validateForm();
    };
   
    const updateSecretAnswer = (value = '') => {
        allow.aString(value);
        formStart();
        const newValue = value.trimStart();
        secretAnswer.set(newValue);
        validateSecretAnswer();
        if (validateEntireForm.get())
            validateForm();
    };
   
    const updateEmailAddress = (value = '') => {
        allow.aString(value);
        formStart();
        const newValue = value.trimStart();
        emailAddress.set(newValue);
        validateEmailAddress();
        if (validateEntireForm.get())
            validateForm();
    };
   
    const updateNoEmailAddressChecked = (event = {}) => {
        allow.anObject(event);
        formStart();
        if (event.type === 'change') {
            if (!noEmailAddressChecked.get()) {
                emailAddress.set('');
                emailAddressError.set(null);
                confirmEmailAddress.set('');
                confirmEmailAddressError.set(null);
            }
            noEmailAddressChecked.set(!noEmailAddressChecked.get());
        }
        if (validateEntireForm.get())
            validateForm();
    };
   
    const updateAgreementChecked = (event = {}) => {
        allow.anObject(event);
        formStart();
        if (event.type === 'change')
            agreementChecked.set(!agreementChecked.get());
        validateAgreementChecked();
        if (validateEntireForm.get())
            validateForm();
    };
   
    const updateConfirmEmailAddress = (value = '') => {
        allow.aString(value);
        formStart();
        const newValue = value.trimStart();
        confirmEmailAddress.set(newValue);
        validateConfirmEmailAddress();
        if (validateEntireForm.get())
            validateForm();
    };
   
    const validateAgreementChecked = () => {
        const isValid = agreementChecked.get();
        if (agreementCheckedError.get() === isValid)
            agreementCheckedError.set(!isValid);
        return isValid;
    };
   
    const validateConfirmEmailAddress = () => {
        const isValid = confirmEmailAddress.get() !== '' && emailAddress.get() === confirmEmailAddress.get();
        if (confirmEmailAddressError.get() === isValid)
            confirmEmailAddressError.set(!isValid);
        return noEmailAddressChecked.get() || isValid;
    };
   
    const validateConfirmNewPassword = () => {
        const isValid = confirmNewPassword.get() !== '' && newPassword.get() === confirmNewPassword.get();
        if (confirmNewPasswordError.get() === isValid)
            confirmNewPasswordError.set(!isValid);
        return isValid;
    };
   
    const validateCurrentPassword = () => {
        const isValid = currentPassword.get() !== '';
        if (currentPasswordError.get() === isValid)
            currentPasswordError.set(!isValid);
        return isValid;
    };
   
    const validateEmailAddress = () => {
        const isValid = emailAddress.get() !== '';
        if (emailAddressError.get() === isValid)
            emailAddressError.set(!isValid);
        return noEmailAddressChecked.get() || isValid;
    };
   
    const validateForm = () => {
        if (!validateEntireForm.get())
            validateEntireForm.set(true);
        let errorFieldRef = null;
        if (usernameVisible && !validateUsername())
            errorFieldRef = usernameRef;
        if (passwordVisible && !validateCurrentPassword())
            errorFieldRef = currentPasswordRef;
        if (passwordVisible && !validateNewPassword())
            errorFieldRef = newPasswordRef;
        if (passwordVisible && !validateConfirmNewPassword())
            errorFieldRef = confirmNewPasswordRef;
        if (secretQuestionVisible && !validateSecretQuestion())
            errorFieldRef = secretQuestionRef;
        if (secretQuestionVisible && !validateSecretAnswer())
            errorFieldRef = secretAnswerRef;
        if (emailVisible && !validateEmailAddress())
            errorFieldRef = emailAddressRef;
        if (emailVisible && !validateConfirmEmailAddress())
            errorFieldRef = confirmEmailAddressRef;
        if (usernameVisible && passwordVisible && secretQuestionVisible && emailVisible && !validateAgreementChecked())
            errorFieldRef = agreementCheckedRef;
        const messages = getValidationMessages();
        validationMessages.set(messages);
        if (messages.length) {
            const errorString = messages.map(x => x.props.description).join(', ');
            conversion.failValidation(errorString);
        }
        return messages.length ? errorFieldRef : null;
    };
   
    const validateNewPassword = () => {
        const isValid = newPassword.get() !== '';
        if (newPasswordError.get() === isValid)
            newPasswordError.set(!isValid);
        return isValid;
    };
   
    const validateSecretAnswer = () => {
        const isValid = secretAnswer.get() !== '';
        if (secretAnswerError.get() === isValid)
            secretAnswerError.set(!isValid);
        return isValid;
    };
   
    const validateSecretQuestion = () => {
        const isValid = secretQuestion.get() !== '';
        if (secretQuestionError.get() === isValid)
            secretQuestionError.set(!isValid);
        return isValid;
    };
   
    const validateUsername = () => {
        const isValid = username.get() !== '';
        if (usernameError.get() === isValid)
            usernameError.set(!isValid);
        return isValid;
    };
   
    const getApiErrorMessage = () => {
        if (!apiErrorMessage.get())
            return null;
        return translate(apiErrorMessage.get());
    };
   
    return <>
        <Div
            isContainer={true}
            paddingySM={1} paddingyMD={2} paddingyLG={3} paddingyXL={4}
        >
            <fieldset style={{
                border: 0,
                margin: 0,
                padding: 0,
            }}>
                <legend>
                    <Div isRow={true}>
                        <Div cols={12}>
                            <H1>
                                {capitalizeFirstLetter(translate('Update Account').toLowerCase())}
                            </H1>
                        </Div>
                    </Div>
                </legend>
                <Div isRow={true}>
                    <Div cols={9} style={{paddingTop: 10, marginLeft: 0}}>
                        <Alert
                            hideIcon={true}>
                            <p className="ds-c-alert__text">
                                <TranslatedSpan english={'Your account needs to be updated to protect your information.'}/>
                            </p>
                        </Alert>
                        <div></div>
                    </Div>
                </Div>
                <Div paddingBottom={1} paddingTop={3}>
                    <SubHeading style={{fontSize: 14, fontWeight: 400}}>
                        <TranslatedSpan english={'All fields required.'}/>
                    </SubHeading>
                </Div>
                <ValidationAlerts
                    heading={`${translate('Error')}: ${translate('Complete these items to get your username.')}`}
                    style={{paddingRight: 0}}
                    validationMessages={validationMessages.get()}
                />
   
                <ApiErrorAlert errorMessage={getApiErrorMessage()}/>
   
                <Div isRow={true}>
                    <Div
                        cols={7}
                        paddingRight={2} paddingRightSM={4} paddingRightMD={6} paddingRightLG={7}>
   
                        {/* Username section */}
                        {usernameVisible &&
                  <Div isRow={true}>
                      <Div cols={12} colsMD={10}>
                          <Div paddingTop={2}>
                              <H2 style={{marginTop: 8}}>
                                  <TranslatedSpan english={'Update Username'}/>
                              </H2>
                          </Div>
                          <InputField
                              aria-invalid={usernameError.get().toString()}
                              errorMessage={usernameError.get() ? `${translate('Error')}: ${translate('Please enter a username.')}` : null}
                              inputRef={setUsernameRef}
                              label={translate('New Username')}
                              name={'Username'}
                              onClick={formStart}
                              onBlur={event => updateUsername(event.currentTarget.value)}
                              onChange={event => updateUsername(event.currentTarget.value)}
                              style={{minWidth: '100%'}}
                              value={username.get()}
                          />
                          {width < the.minimumMediumViewportWidth &&
                        <Div>
                            <span
                                onClick={toggleUsername}
                                style={{
                                    color: the.color.tarheelBlue,
                                    cursor: 'pointer',
                                    textDecoration: 'underline',
                                }}>
                                {`${translate('Username guidelines')} `}
                            </span>
                            <span
                                onClick={() => {
                                    toggleUsername();
                                    setUsernameExpand(!usernameExpand);
                                    setUsernameDisplay(!usernameDisplay);
                                }}>
                                <Caret up={usernameExpand}></Caret>
                            </span>
                            <Div style={{display: usernameToggle ? 'block' : 'none'}}>
                                <div style={{
                                    fontSize: '0.9em'
                                }}>
                                    <div>
                                        <p style={{fontWeight: 500}}>
                                            <TranslatedSpan english={'Username guidelines'}/>
                                        </p>
                                        <p>
                                            <TranslatedSpan english={'Do\'s'}/>
                                        </p>
                                        <ul
                                            className={'ds-c-list'}
                                            style={{paddingLeft: 24}}
                                        >
                                            <li style={{paddingLeft: 10}}>
                                                <TranslatedSpan english={'Must be 8-30 characters long with no spaces'}/>
                                            </li>
                                            <li style={{paddingLeft: 10}}>
                                                <TranslatedSpan english={'Can have letters, numbers, and these special characters: @ ! . - _ $'}/>
                                            </li>
                                            <li style={{paddingLeft: 10}}>
                                                <TranslatedSpan english={'Must have at least 4 letters'}/>
                                            </li>
                                            <li style={{paddingLeft: 10}}>
                                                <TranslatedSpan english={'Can be your email address'}/>
                                            </li>
                                        </ul>
                                        <p>
                                            <TranslatedSpan english={'Don\'ts'}/>
                                        </p>
                                        <ul
                                            className={'ds-c-list'}
                                            style={{paddingLeft: 24}}
                                        >
                                            <li style={{paddingLeft: 10}}>
                                                <TranslatedSpan english={`Can't include your Medicare Number or Social Security number`}/>
                                            </li>
                                            <li style={{paddingLeft: 10}}>
                                                <TranslatedSpan english={`Can’t be the same as your password`}/>
                                            </li>
                                            <li style={{paddingLeft: 10}}>
                                                <TranslatedSpan english={'Can’t have a special character as the first or last character'}/>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </Div>
                        </Div>}
                      </Div>
                  </Div>}
   
                        {/* Current password section */}
                        {passwordVisible &&
                  <Div>
                      <Div isRow={true}>
                          <Div cols={12} colsMD={10}>
                              <Div paddingTop={2}>
                                  <H2 style={{marginTop: 8}}>
                                      <TranslatedSpan english={'Current Password'}/>
                                  </H2>
                              </Div>
                              <Div style={{paddingTop: 8, paddingBottom: 0}}>
                                  <SubHeading style={{fontSize: 16, fontWeight: 6, color: the.color.smokyGrey}}>
                                      <TranslatedSpan english={'Enter temporary password if you were given one'}/>
                                  </SubHeading>
                              </Div>
                              <EnterPasswordSection
                                  columnWidth={12}
                                  errorMessage={currentPasswordError.get() ? `${translate('Error')}: ${translate('Please enter a password.')}` : null}
                                  inputRef={setCurrentPasswordRef}
                                  label={translate('Current Password')}
                                  onBlur={event => updateCurrentPassword(event.currentTarget.value)}
                                  onChange={event => updateCurrentPassword(event.currentTarget.value)}
                                  showForgotPasswordLink={false}
                                  value={currentPassword.get()}
                              />
                              {width < the.minimumMediumViewportWidth &&
                           <Div>
                               <span
                                   onClick={toggleCurrentPassword}
                                   style={{
                                       color: the.color.tarheelBlue,
                                       cursor: 'pointer',
                                       textDecoration: 'underline',
                                   }}>
                                   {`${translate('Password guidelines')} `}
                               </span>
                               <span
                                   onClick={() => {
                                       toggleCurrentPassword();
                                       setCurrentPasswordExpand(!currentPasswordExpand);
                                       setCurrentPasswordDisplay(!currentPasswordDisplay);
                                   }}>
                                   <Caret up={currentPasswordExpand}></Caret>
                               </span>
                               <Div style={{display: currentPasswordDisplayed ? 'block' : 'none'}}>
                                   <div style={{
                                       fontSize: '0.9em'
                                   }}>
                                       <div style={{marginTop: '8px'}}>
                                           <TranslatedSpan english={'Do\'s'}/>
                                       </div>
                                       <ul className="ds-c-list">
                                           <li>
                                               <TranslatedSpan english={'Must be 8-16 characters long'}/>
                                           </li>
                                           <li>
                                               <TranslatedSpan english={'Must have at least 1 letter'}/>
                                           </li>
                                           <li>
                                               <TranslatedSpan english={'Must have at least 1 number'}/>
                                           </li>
                                           <li>
                                               <TranslatedSpan english={'Must have 1 or more of only these special characters: @ ! $ % ^ * ( )'}/>
                                           </li>
                                           <li>
                                               <TranslatedSpan english={'Must be different from your last 6 passwords'}/>
                                           </li>
                                       </ul>
                                       <TranslatedSpan english={'Don\'ts'}/>
                                       <ul className="ds-c-list">
                                           <li>
                                               <TranslatedSpan english={'Can\'t contain your username'}/>
                                           </li>
                                           <li>
                                               <TranslatedSpan english={'Can\'t include your Medicare Number or Social Security number'}/>
                                           </li>
                                       </ul>
                                   </div>
                               </Div>
                           </Div>}
                          </Div>
                      </Div>
                      <Div isRow={true}>
                          <Div cols={12} colsMD={10}>
                              <Div paddingTop={2}>
                                  <H2 style={{marginTop: 8}}>
                                      <TranslatedSpan english={'Update Password'}/>
                                  </H2>
                              </Div>
                              <EnterPasswordSection
                                  columnWidth={12}
                                  errorMessage={newPasswordError.get() ? `${translate('Error')}: ${translate('Please enter a new password.')}` : null}
                                  inputRef={setNewPasswordRef}
                                  label={translate('New password')}
                                  onBlur={event => updateNewPassword(event.currentTarget.value)}
                                  onChange={event => updateNewPassword(event.currentTarget.value)}
                                  showForgotPasswordLink={false}
                                  value={newPassword.get()}
                              />
                              {width < the.minimumMediumViewportWidth &&
                           <Div>
                               <span
                                   onClick={togglePassword}
                                   style={{
                                       color: the.color.tarheelBlue,
                                       cursor: 'pointer',
                                       textDecoration: 'underline',
                                   }}>
                                   {`${translate('Password guidelines')} `}
                               </span>
                               <span
                                   onClick={() => {
                                       togglePassword();
                                       setPasswordExpand(!passwordExpand);
                                       setPasswordDisplay(!passwordDisplay);
                                   }}>
                                   <Caret up={passwordExpand}></Caret>
                               </span>
                               <Div style={{display: passwordToggle ? 'block' : 'none'}}>
                                   <div style={{
                                       fontSize: '0.9em'
                                   }}>
                                       <div style={{marginTop: '8px'}}>
                                           <TranslatedSpan english={'Do\'s'}/>
                                       </div>
                                       <ul className="ds-c-list">
                                           <li>
                                               <TranslatedSpan english={'Must be 8-16 characters long'}/>
                                           </li>
                                           <li>
                                               <TranslatedSpan english={'Must have at least 1 letter'}/>
                                           </li>
                                           <li>
                                               <TranslatedSpan english={'Must have at least 1 number'}/>
                                           </li>
                                           <li>
                                               <TranslatedSpan english={'Must have 1 or more of only these special characters: @ ! $ % ^ * ( )'}/>
                                           </li>
                                           <li>
                                               <TranslatedSpan english={'Must be different from your last 6 passwords'}/>
                                           </li>
                                       </ul>
                                       <TranslatedSpan english={'Don\'ts'}/>
                                       <ul className="ds-c-list">
                                           <li>
                                               <TranslatedSpan english={'Can\'t contain your username'}/>
                                           </li>
                                           <li>
                                               <TranslatedSpan english={'Can\'t include your Medicare Number or Social Security number'}/>
                                           </li>
                                       </ul>
                                   </div>
                               </Div>
                           </Div>}
                              <EnterPasswordSection
                                  columnWidth={12}
                                  errorMessage={confirmNewPasswordError.get() ? `${translate('Error')}: ${translate('Please confirm your password.')}` : null}
                                  inputRef={setconfirmNewPasswordRef}
                                  label={translate('Confirm new password')}
                                  onBlur={event => updateConfirmNewPassword(event.currentTarget.value)}
                                  onChange={event => updateConfirmNewPassword(event.currentTarget.value)}
                                  showForgotPasswordLink={false}
                                  value={confirmNewPassword.get()}
                              />
                          </Div>
                      </Div>
                  </Div>}
   
                        {/* Secret Question section */}
                        {secretQuestionVisible &&
                  <Div isRow={true}>
                      <Div cols={12} colsMD={10}>
                          <Div paddingTop={2}>
                              <H2 style={{marginTop: 8}}>
                                  <TranslatedSpan english={'Update Secret Question'}/>
                              </H2>
                          </Div>
                          <DropDown
                              aria-invalid={secretQuestionError.get().toString()}
                              errorMessage={secretQuestionError.get() ? `${translate('Error')}: ${translate('Please select a secret question.')}` : null}
                              inputRef={setSecretQuestionRef}
                              label={translate('Secret Question')}
                              name={'secretQuestion'}
                              onBlur={event => updateSecretQuestion(event.currentTarget.value)}
                              onChange={event => updateSecretQuestion(event.currentTarget.value)}
                              options={questionList}
                              style={{color: the.color.smokyGrey}}
                              value={secretQuestion.get()}
                              {...remainingProps}
                          />
                          <InputField
                              aria-invalid={secretAnswerError.get().toString()}
                              errorMessage={secretAnswerError.get() ? `${translate('Error')}: ${translate('Please enter a secret answer.')}` : null}
                              inputRef={setSecretAnswerRef}
                              label={translate('Secret answer')}
                              name={'secretAnswer'}
                              onClick={formStart}
                              onBlur={event => updateSecretAnswer(event.currentTarget.value)}
                              onChange={event => updateSecretAnswer(event.currentTarget.value)}
                              style={{minWidth: '100%'}}
                              value={secretAnswer.get()}
                          />
                      </Div>
                  </Div>}
   
                        {/* Add email section */}
                        {emailVisible &&
                  <Div>
                      <Div isRow={true}>
                          <Div cols={12} colsMD={10}>
                              <Div paddingTop={2}>
                                  <H2 style={{marginTop: 8}}>Add Email</H2>
                              </Div>
                              <InputField
                                  aria-invalid={emailAddressError.get()?.toString()}
                                  disabled={noEmailAddressChecked.get()}
                                  errorMessage={emailAddressError.get() ? `${translate('Error')}: ${translate('I don\'t have an email address.')}` : null}
                                  inputRef={setEmailAddressRef}
                                  label={translate('Email address')}
                                  name={'emailAddress'}
                                  onClick={formStart}
                                  onBlur={event => updateEmailAddress(event.currentTarget.value)}
                                  onChange={event => updateEmailAddress(event.currentTarget.value)}
                                  style={{minWidth: '100%'}}
                                  value={emailAddress.get()}
                              />
                              <InputField
                                  aria-invalid={confirmEmailAddressError.get()?.toString()}
                                  disabled={noEmailAddressChecked.get()}
                                  errorMessage={confirmEmailAddressError.get() ? `${translate('Error')}: ${translate('Confirm your email address or select "I don\'t have an email address".')}` : null}
                                  inputRef={setConfirmEmailAddressRef}
                                  label={translate('Confirm email address')}
                                  name={'confirmEmailAddress'}
                                  onClick={formStart}
                                  onBlur={event => updateConfirmEmailAddress(event.currentTarget.value)}
                                  onChange={event => updateConfirmEmailAddress(event.currentTarget.value)}
                                  style={{minWidth: '100%'}}
                                  value={confirmEmailAddress.get()}
                              />
                          </Div>
                      </Div>
                      <Div isRow={true}>
                          <Div cols={12}>
                              <Div paddingTop={2}>
                                  <H5>
                                      <TranslatedSpan english={'Don\'t have an email address?'}/>
                                  </H5>
                              </Div>
                              <p style={{
                                  marginBottom: 0,
                                  marginTop: 8,
                              }}>
                                  <TranslatedSpan english={'We\'ll send information about your account by mail to the address on file.'}/>
                              </p>
                              <Checkbox
                                  checked={noEmailAddressChecked.get()}
                                  className={'ds-u-margin-top--0'}
                                  name={'noEmailAddressCheckbox'}
                                  onBlur={event => updateNoEmailAddressChecked(event)}
                                  onChange={event => updateNoEmailAddressChecked(event)}
                                  type={'checkbox'}
                                  title={translate('I don\'t have an email address.')}
                                  value={'noEmailAddress'}
                              >
                              </Checkbox>
                          </Div>
                      </Div>
                  </Div>}
   
                        {/* Agree to statements section */}
                        {usernameVisible && passwordVisible && secretQuestionVisible && emailVisible &&
                  <Div isRow={true}>
                      <Div cols={12}>
                          <Div paddingTop={2}>
                              <H3>
                                  <TranslatedSpan english={'Agree to the statements below'}/>
                              </H3>
                          </Div>
                          <Div>
                              <Checkbox
                                  aria-invalid={agreementCheckedError.get().toString()}
                                  checked={agreementChecked.get()}
                                  className={'ds-u-margin-top--0'}
                                  errorMessage={agreementCheckedError.get() ? `${translate('Error')}: ${translate('Review and check the box to continue to the next step.')}` : null}
                                  inputRef={setAgreementCheckedRef}
                                  name={'agreementCheckbox'}
                                  onBlur={event => updateAgreementChecked(event)}
                                  onChange={event => updateAgreementChecked(event)}
                                  type={'checkbox'}
                                  value={'agreed'}
                                  title={translate('By checking this box, I agree to the following')}
                              >
                                  <span
                                      onClick={toggleTermsAndConditions}
                                      style={{
                                          color: the.color.tarheelBlue,
                                          cursor: 'pointer',
                                          textDecoration: 'underline',
                                          paddingLeft: 40
                                      }}>
                                      <TranslatedSpan english={'terms & conditions'}/>
                                  </span>
                                  <span
                                      onClick={() => {
                                          toggleTermsAndConditions();
                                          setExpand(!expand);
                                          setDisplay(!display);
                                      }}>
                                      <Caret up={expand}></Caret>
                                  </span>
                                  <Div style={{display: termsAndConditionsDisplayed ? 'block' : 'none', paddingLeft: 40}}>
                                      <TermsAndConditions />
                                      <p>
                                          <span
                                              style={{
                                                  color: the.color.tarheelBlue,
                                                  cursor: 'pointer',
                                                  textDecoration: 'underline',
                                              }}
                                              onClick={toggleTermsAndConditions}>
                                              <TranslatedSpan english={'Read less'}/>{' - '}
                                          </span>
                                      </p>
                                  </Div>
                              </Checkbox>
                          </Div>
                      </Div>
                  </Div>}
   
                        {/* Button Section */}
                        <StackingButtons
                            button1={getCancelButton()}
                            button2={getUpdateAccountButton()}
                        />
                    </Div>
      
                    {/* User guidelines section */}
                    {width > the.minimumMediumViewportWidth &&
               <Div cols={5}>
                   <div style={{
                       borderLeft: '1px solid #ddd',
                       paddingLeft: 16,
                       fontSize: '0.9em'
                   }}>
                       {usernameVisible &&
                     <div>
                         <p style={{fontWeight: 500}}>
                             <TranslatedSpan english={'Username guidelines'}/>
                         </p>
                         <p>
                             <TranslatedSpan english={'Do\'s'}/>
                         </p>
                         <ul
                             className={'ds-c-list'}
                             style={{paddingLeft: 24}}
                         >
                             <li style={{paddingLeft: 10}}>
                                 <TranslatedSpan english={'Must be 8-30 characters long with no spaces'}/>
                             </li>
                             <li style={{paddingLeft: 10}}>
                                 <TranslatedSpan english={'Can have letters, numbers, and these special characters: @ ! . - _ $'}/>
                             </li>
                             <li style={{paddingLeft: 10}}>
                                 <TranslatedSpan english={'Must have at least 4 letters'}/>
                             </li>
                             <li style={{paddingLeft: 10}}>
                                 <TranslatedSpan english={'Can be your email address'}/>
                             </li>
                         </ul>
                         <p>
                             <TranslatedSpan english={'Don\'ts'}/>
                         </p>
                         <ul
                             className={'ds-c-list'}
                             style={{paddingLeft: 24}}
                         >
                             <li style={{paddingLeft: 10}}>
                                 <TranslatedSpan english={`Can't include your Medicare Number or Social Security number`}/>
                             </li>
                             <li style={{paddingLeft: 10}}>
                                 <TranslatedSpan english={'Can’t be the same as your password'}/>
                             </li>
                             <li style={{paddingLeft: 10}}>
                                 <TranslatedSpan english={'Can’t have a special character as the first or last character'}/>
                             </li>
                         </ul>
                     </div>}
   
                       {passwordVisible &&
                     <div>
                         <div className="ds-h5" style={{marginBottom: '16px'}}>
                             <TranslatedSpan english={'Password guidelines'}/>
                         </div>
                         <div style={{marginTop: '8px'}}>
                             <TranslatedSpan english={'Do\'s'}/>
                         </div>
                         <ul className="ds-c-list">
                             <li>
                                 <TranslatedSpan english={'Must be 8-16 characters long'}/>
                             </li>
                             <li>
                                 <TranslatedSpan english={'Must have at least 1 letter'}/>
                             </li>
                             <li>
                                 <TranslatedSpan english={'Must have at least 1 number'}/>
                             </li>
                             <li>
                                 <TranslatedSpan english={'Must have 1 or more of only these special characters: @ ! $ % ^ * ( )'}/>
                             </li>
                             <li>
                                 <TranslatedSpan english={'Must be different from your last 6 passwords'}/>
                             </li>
                         </ul>
                         <TranslatedSpan english={'Don\'ts'}/>
                         <ul className="ds-c-list">
                             <li>
                                 <TranslatedSpan english={`Can't contain your username`}/>
                             </li>
                             <li>
                                 <TranslatedSpan english={`Can't include your Medicare Number or Social Security number`}/>
                             </li>
                         </ul>
                     </div>}
                   </div>
               </Div>}
                </Div>
            </fieldset>
        </Div>
    </>;
}
